import { Pipe, PipeTransform } from '@angular/core'

@Pipe({name: 'truncate'})
export class TruncatePipe implements PipeTransform {
	transform(value: string, args: string[]) : string {
		console.log("TruncatePipe args.length: " + args.length)

    	let limit = args.length > 0 ? parseInt(args[0], 10) : 10;
    	let trail = args.length > 1 ? args[1] : '...';

    	return value.length > limit ? value.substring(0, limit) + trail : value;
	}
}


// WEBPACK FOOTER //
// /Users/kala/Sites/weeloy_website_engine/website-new-template-fun/src/app/truncate.pipe.ts